import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';

@Component({
  selector: 'app-title-block-bullets',
  templateUrl: './title-block-bullets.component.html',
  styleUrls: ['./title-block-bullets.component.scss']
})
export class TitleBlockBulletsComponent implements OnInit {
  @Input() rendering: ComponentRendering;

  jssStylingService: JssStylingService;
  dynamicClass: string;

  constructor(jssStylingService: JssStylingService,) { 
    this.jssStylingService = jssStylingService;
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('titleBlockBullets component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
  }
}
